// NOTE: this file was auto-generated on 2023-03-29T03:48:07.906Z
import classNames from 'classnames';
import * as SubframeCore from '@subframe/core';
import React from 'react';
import styles from './Divider.module.scss';

interface DividerRootProps extends React.ButtonHTMLAttributes<HTMLDivElement> {
  variant?: 'brand' | 'neutral' | 'destructive';
  thickness?: 'Normal' | 'Bold';
  className?: string;
}

const DividerRoot = React.forwardRef<HTMLElement, DividerRootProps>(
  function ButtonRoot(
    {
      variant = 'neutral',
      thickness = 'Normal',
      className,
      ...otherProps
    }: DividerRootProps,
    ref,
  ) {
    return (
      <div
        className={classNames(styles['stack'], className, styles['divider'], {
          [styles['variant-brand']]: variant === 'brand',
          [styles['variant-neutral']]: variant === 'neutral',
          [styles['thickness-normal']]: thickness === 'Normal',
          [styles['thickness-bold']]: thickness === 'Bold',
        })}
        ref={ref as any}
        {...otherProps}
      />
    );
  },
);

export const Divider = DividerRoot;
